<template>
  <div :class="$style.faqHero">
    <div :class="$style.heroTextContainer">
      <div :class="$style.heroTextContainerInner">
        <TransitionOnScroll
          :translateY="isMqLarger ? 20 : 10"
          rootMargin="0px"
          @intersecting="isTextIntersecting = $event"
        >
          <Heading :class="$style.heroTitle" :tag="HEADINGS.h1"> {{ title }} </Heading>
        </TransitionOnScroll>
        <TransitionOnScroll
          :translateY="isMqLarger ? 35 : 20"
          rootMargin="0px"
          :isIntersecting="isTextIntersecting"
        >
          <LineBreakResolver :text="subtitle" />
        </TransitionOnScroll>
      </div>
    </div>
    <IconHeroBgLine :class="$style.bgLine" />
    <TransitionOnScroll
      :class="$style.heroIconWrap"
      :translateY="isMqLarger ? 60 : 38"
      rootMargin="0px"
      :isIntersecting="isTextIntersecting"
    >
      <IconWomanGiantScreen :class="$style.heroIcon" />
    </TransitionOnScroll>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Heading, { HEADINGS } from '@/components/Heading/Heading.vue'
import IconHeroBgLine from '@/components/_icons/IconHeroBgLine.svg'
import IconWomanGiantScreen from '@/components/_icons/IconWomanGiantScreen.svg'
import LineBreakResolver from '@/components/LineBreakResolver.vue'
import TransitionOnScroll from '@/components/TransitionOnScroll.vue'

export default {
  name: 'FaqHero',
  components: {
    Heading,
    IconHeroBgLine,
    IconWomanGiantScreen,
    LineBreakResolver,
    TransitionOnScroll,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    subtitle: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      HEADINGS,
      isTextIntersecting: false,
    }
  },

  computed: {
    ...mapGetters({
      isMqLarger: 'viewport/isMqLarger',
    }),
  },
}
</script>

<style lang="scss" module>
.faqHero {
  position: relative;
  background-color: $color-brand-green-bg;
  padding-top: $site-header-height-small;
  text-align: center;

  @include min-screen($mq-large) {
    padding-top: $site-header-height;
  }
}

.heroTextContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 360px;

  @include min-screen($mq-large) {
    height: 420px;
  }
}

.heroTextContainerInner {
  margin: auto;
  padding: 0 40px 60px;
  max-width: 730px;
  color: $color-brand-navy;

  @include min-screen($mq-large) {
    padding: 0 60px 60px;
  }

  .heroTitle {
    margin-top: 0;
  }
}

.bgLine {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 95%;

  @include max-screen($mq-medium) {
    bottom: 5px;
    width: 90%;

    path {
      stroke-width: 12px !important;
    }
  }

  @include min-max-screen($mq-tiny, $mq-medium) {
    path {
      stroke-width: 8px !important;
    }
  }

  @include min-max-screen($mq-medium, $mq-large) {
    path {
      stroke-width: 6px !important;
    }
  }

  @include min-screen($mq-large) {
    bottom: -1%;
    width: 90%;
  }
}

.heroIconWrap {
  position: absolute;
  bottom: 0;
  left: 50%;
}

.heroIcon {
  vertical-align: top;
  height: 220px;
  transform: translate(-49%, 42%);

  @include min-screen($mq-large) {
    height: 250px;
  }
}
</style>
